// Hatim ilerlemesinin düzenlenebilirliği ve kalan süre etiketi.
// Mobil uygulamayla aynı kural: components/profile/modals/HatimProgressModal
// içindeki `canEdit = instance.active && !instance.isCompleted`.

export function canEditInstance(instance) {
  return Boolean(instance?.active && !instance?.isCompleted);
}

// Eşikler mobildeki useRemainingLabel ile aynı: 1 günden az kırmızı,
// 3 güne kadar turuncu, sonrası yeşil.
export function remainingLabel(endDate, t, now = Date.now()) {
  const end = endDate ? new Date(endDate) : null;
  if (!end || Number.isNaN(end.getTime())) return null;
  const ms = end.getTime() - now;
  if (ms <= 0) return { text: t("hatim_finished"), tone: "text-terakkiNeutral", finished: true };

  const hours = Math.floor(ms / 3600000);
  const days = Math.floor(hours / 24);
  const tone = days < 1 ? "text-terakkiError" : days <= 3 ? "text-terakkiWarning" : "text-terakkiSuccess";
  if (days >= 1) return { text: `${days} ${t("hatim_days_left")}`, tone, finished: false };
  if (hours >= 1) return { text: `${hours} ${t("hatim_hours_left")}`, tone, finished: false };
  return {
    text: `${Math.max(1, Math.floor(ms / 60000))} ${t("hatim_minutes_left")}`,
    tone,
    finished: false,
  };
}

/** Aralık listesindeki toplam sayfa sayısı (uçlar dahil). */
export function sumPages(ranges = []) {
  return (ranges || []).reduce(
    (acc, r) => acc + Math.max(0, Number(r.endPage) - Number(r.startPage) + 1),
    0
  );
}

function rangeKey(r) {
  return `${Number(r.startPage)}-${Number(r.endPage)}`;
}

/** İki aralık listesi aynı mı (sıra önemsiz). */
export function rangesEqual(a = [], b = []) {
  if ((a || []).length !== (b || []).length) return false;
  const left = (a || []).map(rangeKey).sort();
  const right = (b || []).map(rangeKey).sort();
  return left.every((k, i) => k === right[i]);
}

/** Aralık seçili mi. */
export function isRangeSelected(selected = [], range) {
  return (selected || []).some((r) => rangeKey(r) === rangeKey(range));
}

/**
 * Bir aralığı seçime ekler ya da çıkarır.
 * Mobildeki toggleRange gibi, atanan toplam sayfayı aşan seçime izin vermez.
 */
export function toggleRange(selected = [], range, assignedTotal = 0) {
  const exists = isRangeSelected(selected, range);
  const next = exists
    ? selected.filter((r) => rangeKey(r) !== rangeKey(range))
    : [...selected, { startPage: Number(range.startPage), endPage: Number(range.endPage) }];
  if (!exists && assignedTotal > 0 && sumPages(next) > assignedTotal) return selected;
  return next;
}

/**
 * Kodla katılırken seçilebilecek sayfa blokları (20 sayfalık cüzler).
 * Başkasının aldığı cüzler listeden düşer; son blok toplam sayfada kesilir.
 */
export function availableJuzBlocks(info) {
  const total = Number(info?.totalAmount || 0);
  if (!Number.isFinite(total) || total <= 0) return [];
  const taken = new Set((info?.rangeInfo?.takenJuzs || []).map(Number));
  const blocks = [];
  for (let juz = 1; (juz - 1) * 20 + 1 <= total; juz++) {
    if (taken.has(juz)) continue;
    blocks.push({
      juz,
      startPage: (juz - 1) * 20 + 1,
      endPage: Math.min(total, juz * 20),
    });
  }
  return blocks;
}
